module.exports = __webpack_public_path__ + "img/SketchPngc8812316309812294af6b18766c6ff8699eb1296686d15196605c66fd620d3a9.83b7d365.png";